import { generateUtilityClasses } from '@mui/material';

export interface EmptyViewClasses {
  root: string;
  icon: string;
  header: string;
  content: string;
}

const emptyViewClasses: EmptyViewClasses = generateUtilityClasses('EmptyView', [
  'root',
  'icon',
  'header',
  'content',
]);

export default emptyViewClasses;
